export default "__VITE_ASSET__D1w78qTg__"